module.exports = __webpack_public_path__ + "img/group-icon.06f99653.svg";